export const eventHosts = (params: { eventId: number }) => `event:${params.eventId}`;
